import {ITreeNode} from './mock';
import {ITagsList} from '../../../../api/types/tagFoldering.type';

export const getNodeById = (
  nodes: ITreeNode[],
  id: string
): ITreeNode | null => {
  for (const node of nodes) {
    if (node.id === id) {
      return node;
    }

    if (node.children?.length) {
      const found = getNodeById(node.children, id);
      if (found) {
        return found;
      }
    }
  }

  return null;
};

type TreeNode = {
  id: string;
  label: string;
  documentCount?: number;
  children?: TreeNode[];
  [key: string]: any;
  isGroup?: boolean;
  skipParent?: boolean;
};

export const transformTreeData = (nodes: TreeNode[]): TreeNode[] => {
  return nodes.map((node) => {
    const hasChildren = node.children && node.children?.length > 0;
    const count = node.documentCount ?? 0;
    const isGroup = node.isGroup ?? false;
    let label = node.label?.split('(')[0]?.trim() ?? '';

    const newNode = {
      ...node,
      ...(hasChildren || isGroup ? {skipParent: true} : {}),
      ...((count < 1 || count >= 250) && !isGroup ? {disabled: true} : {}),
      ...(isGroup ? {label} : {label: node.label}),
      children: hasChildren ? transformTreeData(node.children ?? []) : [],
    };

    return newNode;
  });
};

export const buildTree = (
  items: ITagsList[] = [],
  {
    idKey = 'id',
    parentKey = 'parent',
    rootParentValue = '#',
    textKey = 'text',
    countKey = 'documentCount',
    childrenKey = 'children',
  } = {}
) => {
  if (!Array.isArray(items)) return [];

  const nodeMap = {};

  const getLabelFromText = (text = '') => {
    return String(text).replace(/\s{0,20}\(\d{1,10}\)\s{0,20}$/, '');
  };

  const getCountFromText = (text = '') => {
    const match = text.match(/\((\d+)\)/);
    return match ? Number(match[1]) : null;
  };

  items.forEach((item: any) => {
    const label = item.textWithoutCount || getLabelFromText(item[textKey]);
    const count = String(
      item[countKey] || getCountFromText(item[textKey]) || 0
    );
    const isCascadeEnabled = item.li_attr?.isCascadeEnabled ?? false;

    nodeMap[item[idKey]] = {
      ...item,
      label,
      count: item.isGroup ? '' : count,
      documentCount: Number(count),
      text: label,
      isCascadeEnabled,
      showMoreOptions: true,
      [childrenKey]: [],
    };
  });

  const tree = [];

  items.forEach((item) => {
    const node = nodeMap[item[idKey]];
    const parentId = item[parentKey];

    if (parentId === rootParentValue || parentId == null) {
      node.parent = null;
      tree.push(node);
    } else if (nodeMap[parentId]) {
      node.parent = parentId;
      nodeMap[parentId][childrenKey].push(node);
    } else {
      node.parent = null;
      tree.push(node);
    }
  });

  return tree;
};
